import React from "react";
import PropTypes from "prop-types";
import classes from "./page-header.scss";

/**
 * The header for content and tool pages: a small label over a medium title, in the same
 * dark band as the icons page banner (PageBanner). A div, not <header>: the site
 * styles every <header> as the fixed top bar
 */
const PageHeader = ({ label, title, children }) => (
  <div className={classes.wrap}>
    <div className={classes.inner}>
      <div className={classes.text}>
        {label ? <span className={classes.label}>{label}</span> : null}
        <h1>{title}</h1>
      </div>
      {children ? <div className={classes.aside}>{children}</div> : null}
    </div>
  </div>
);

PageHeader.propTypes = {
  label: PropTypes.node,
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default PageHeader;
